import { Account } from './AccountEventEnum';
import { BannerEvent } from './BannerEventEnum';
import { CouponEvents } from './CouponEventEnum';
import { ForgotPassword } from './ForgotPasswordEventEnum';
import { FormEventEnum } from '~/plugins/analytics/enums/FormEventEnum';
import { GameEvent } from './GameEventEnum';
import { LiveChatEvent } from './LiveChatEventEnum';
import { LoginEvent } from './LoginEventEnum';
import { NavigationEvent } from './NavigationEventEnum';
import { Notification } from './NotificationEventEnum';
import { Promotion } from './PromotionEventEnum';
import { RegistrationEvent } from './RegistrationEvent';
import { SearchEvent } from './SearchEventEnum';
import { WelcomeOffer } from './WelcomeOfferEnum';
import { WinnersEvent } from '~/plugins/analytics/enums/WinnersEventEnum';
import { ProgressiveJackpotsEvent } from '~/plugins/analytics/enums/Jackpots';
import { FixedJackpotsEvent } from '~/plugins/analytics/enums/Jackpots';

export default {
  Account,
  BannerEvent,
  CouponEvents,
  ForgotPassword,
  FormEventEnum,
  GameEvent,
  LiveChatEvent,
  LoginEvent,
  NavigationEvent,
  Notification,
  Promotion,
  RegistrationEvent,
  SearchEvent,
  WelcomeOffer,
  WinnersEvent,
  ProgressiveJackpotsEvent,
  FixedJackpotsEvent,
};
